import styled from "@emotion/styled";
import { TableCell } from "@material-ui/core";
import { units } from "../../../types/units";
import { withShowIf } from "../../with-show-if/with-show-If.component";
import { BASE_COLORS } from "../../../emotion-theme";

const shouldForwardProp = (prop: string) => prop !== "active";

export const ResponsiveTableCell = styled(withShowIf(TableCell), {
  shouldForwardProp,
})<{ active?: boolean }>`
  color: ${(props) => (props.active === false ? BASE_COLORS.red : "inherit")};
  padding: 0.5rem 1rem;
  ${units({
    fontSize: "body",
  })};
`;
